var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-card-modal" }, [
    _c(
      "div",
      { staticClass: "card-meta" },
      [
        _c("h2", { staticClass: "mb-2" }, [_vm._v("Billing and Invoice")]),
        _vm._v(" "),
        _vm.trialEnd
          ? _c(
              "VAlert",
              { attrs: { value: true, type: "info" } },
              [
                _vm._v(
                  "\n      You are currently in a free trial period.\n      "
                ),
                _vm.inUpgradeProcess
                  ? [
                      _vm._v(
                        "\n        If you add a card and don't complete the upgrade steps,\n      "
                      )
                    ]
                  : [_vm._v("\n        If you add a card now,\n      ")],
                _vm._v(
                  "\n      you will be migrated to an equivalent paying plan when the trial ends (on " +
                    _vm._s(_vm.trialEnd) +
                    ") at\n      $" +
                    _vm._s(_vm.plan.amount / 100) +
                    " / " +
                    _vm._s(_vm.plan.interval) +
                    " (excluding tax).\n    "
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "VForm",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.addCard.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "card personal-info px-3 py-1 pb-2" }, [
              _c(
                "div",
                { staticClass: "card-information" },
                [
                  _c("h3", [_vm._v("Card Information")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-2 mb-0" }, [
                    _vm._v("Name of Cardholder:")
                  ]),
                  _vm._v(" "),
                  _c("VTextField", {
                    staticClass: "mt-0 mb-0",
                    staticStyle: { "padding-top": "3px" },
                    attrs: {
                      id: "fullname",
                      name: "fullname",
                      autofocus: "",
                      rules: [
                        function() {
                          return (
                            _vm.cardInfos.name.length > 0 ||
                            "This field is required"
                          )
                        }
                      ],
                      autocomplete: "name"
                    },
                    model: {
                      value: _vm.cardInfos.name,
                      callback: function($$v) {
                        _vm.$set(_vm.cardInfos, "name", $$v)
                      },
                      expression: "cardInfos.name"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-1 mb-0" }, [
                    _vm._v("Card Information:")
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "card" })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-information mt-2" },
                [
                  _c("h3", [_vm._v("Invoice Information")]),
                  _vm._v(" "),
                  _c("VTextField", {
                    attrs: {
                      name: "companyName",
                      label: "Company name",
                      autocomplete: "organization"
                    },
                    model: {
                      value: _vm.companyName,
                      callback: function($$v) {
                        _vm.companyName = $$v
                      },
                      expression: "companyName"
                    }
                  }),
                  _vm._v(" "),
                  _c("VTextField", {
                    attrs: {
                      name: "address",
                      label: "Address Line 1",
                      rules: [
                        function() {
                          return (
                            _vm.cardInfos.address_line1.length > 0 ||
                            "This field is required"
                          )
                        }
                      ],
                      required: "",
                      autocomplete: "address-line1"
                    },
                    model: {
                      value: _vm.cardInfos.address_line1,
                      callback: function($$v) {
                        _vm.$set(_vm.cardInfos, "address_line1", $$v)
                      },
                      expression: "cardInfos.address_line1"
                    }
                  }),
                  _vm._v(" "),
                  _c("VTextField", {
                    attrs: {
                      name: "address",
                      label: "Address Line 2",
                      autocomplete: "address-line2"
                    },
                    model: {
                      value: _vm.cardInfos.address_line2,
                      callback: function($$v) {
                        _vm.$set(_vm.cardInfos, "address_line2", $$v)
                      },
                      expression: "cardInfos.address_line2"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-row" }, [
                    _c(
                      "div",
                      { staticClass: "mr-3" },
                      [
                        _c("VTextField", {
                          attrs: { name: "zip", label: "Zip Code" },
                          model: {
                            value: _vm.cardInfos.address_zip,
                            callback: function($$v) {
                              _vm.$set(_vm.cardInfos, "address_zip", $$v)
                            },
                            expression: "cardInfos.address_zip"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mr-3" },
                      [
                        _c("VTextField", {
                          attrs: {
                            name: "city",
                            label: "City",
                            rules: [
                              function() {
                                return (
                                  _vm.cardInfos.address_city.length > 0 ||
                                  "This field is required"
                                )
                              }
                            ],
                            required: ""
                          },
                          model: {
                            value: _vm.cardInfos.address_city,
                            callback: function($$v) {
                              _vm.$set(_vm.cardInfos, "address_city", $$v)
                            },
                            expression: "cardInfos.address_city"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("VAutocomplete", {
                          attrs: {
                            items: _vm.countries,
                            itemText: "name",
                            itemValue: "name",
                            label: "Country",
                            rules: [
                              function() {
                                return (
                                  _vm.cardInfos.address_country.length > 0 ||
                                  "This field is required"
                                )
                              }
                            ],
                            required: ""
                          },
                          nativeOn: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                            }
                          },
                          model: {
                            value: _vm.cardInfos.address_country,
                            callback: function($$v) {
                              _vm.$set(_vm.cardInfos, "address_country", $$v)
                            },
                            expression: "cardInfos.address_country"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.isVATrequired
                ? _c(
                    "div",
                    { staticClass: "card-information mt-2" },
                    [
                      _c("h3", [_vm._v("VAT Identification Number")]),
                      _vm._v(
                        "\n          As you are in Europe please put your company VAT number to avoid paying extra taxes. You\n          can use a service "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://vat-search.eu",
                            target: "_blank"
                          }
                        },
                        [_vm._v("like this one")]
                      ),
                      _vm._v(" to\n          find it easily.\n          "),
                      _c("VTextField", {
                        attrs: {
                          value: "Label Text",
                          name: "vatNumber",
                          label: "VAT id"
                        },
                        model: {
                          value: _vm.vatNumber,
                          callback: function($$v) {
                            _vm.vatNumber = $$v
                          },
                          expression: "vatNumber"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "cb-btn mt-3" }, [
                !_vm.card.id
                  ? _c(
                      "span",
                      [
                        _c(
                          "VBtn",
                          {
                            attrs: {
                              type: "submit",
                              disabled: _vm.addCardLoading,
                              color: "primary"
                            }
                          },
                          [
                            !_vm.addCardLoading
                              ? _c(
                                  "span",
                                  [
                                    _vm._v(" Next "),
                                    _c("VIcon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-arrow-right")
                                    ])
                                  ],
                                  1
                                )
                              : _c("VProgressCircular", {
                                  attrs: { indeterminate: "", color: "white" }
                                })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c(
                          "VBtn",
                          {
                            attrs: { color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleAddCard({})
                              }
                            }
                          },
                          [_vm._v("\n              Next\n            ")]
                        )
                      ],
                      1
                    )
              ])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-footer mt-1" }, [
      _c("i", [_vm._v("Payment Powered by Stripe")]),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://stripe.com",
            title: "Payment Powered By Stripe",
            target: "_blank"
          }
        },
        [
          _c("img", {
            attrs: { width: "200", src: require("@/assets/stripe-payment.png") }
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }